













































































































































































































import Vue from "vue";
import store, { BankRemitStore } from "../services/BankRemitStore";
import BankRemitApi from "../services/BankRemitApi";
import BankOverOutView from "../models/BankOverOutView";
import { CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor } from "@progress/kendo-data-query";
import Paginator from "../../../components/Paginator.vue";
import Pager from "../../../models/Pager";
import DateInput from "../../../components/DateInput.vue";
import MoneyDisplay from "../../../components/MoneyDisplay.vue";
import MoneyInput from "../../../components/MoneyInput.vue";
import { formatDate } from "../../../utils/formatDates";
import configuration, { AppConfiguration } from "@/models/Configuration";
import { bankRemitItemDefaultProps } from "../models/BankRemitItem";


interface Data {
  store: BankRemitStore;
  bankAcc: string;
  partner: string;
  currency: string;
  invoices: BankOverOutView[];

  pager: Pager;
  filter: CompositeFilterDescriptor;
  sort: SortDescriptor[];

  customFilter: CompositeFilterDescriptor | null;
  customSort: SortDescriptor[] | null;

  accDateMin: string;
  accDateMax: string;
  pDateMin: string;
  pDateMax: string;
  configuration: AppConfiguration;
}

interface Computed {
  activeItems: object[];
  columns: any;
  activeFilter: CompositeFilterDescriptor;
  activeSort: SortDescriptor[];
}

export default Vue.extend<Data, {}, Computed, {}>({
  components: {
    Paginator,
    DateInput,
    // MoneyDisplay,
    MoneyInput,
  },

  data() {
    return {
      store,
      bankAcc: "",
      partner: "",
      currency: "",
      invoices: [],

      pager: new Pager(),
      filter: { logic: "and", filters: [] },
      sort: [],

      customFilter: null,
      customSort: null,

      //filters
      accDateMin: "2000. 01. 01.",
      accDateMax: "2999. 12. 31.",
      pDateMin: "2000. 01. 01.",
      pDateMax: "2999. 12. 31.",

      configuration
    };
  },

  async beforeMount() {
    this.currency = this.store.bankRemit.currency;
  },

  methods: {
    formatDate(date: string) {
      return formatDate(date);
    },

    showDetails(item: BankOverOutView) {
      item.selected = !item.selected;
    },

    async addItem(item: BankOverOutView) {
      this.store.bankRemitItem = {...bankRemitItemDefaultProps};

      this.store.bankRemitItem.bankRemit = this.store.bankRemit.id;
      this.store.bankRemitItem.prefix = item.code;
      this.store.bankRemitItem.invoice = item.invoice;
      this.store.bankRemitItem.amount = item.amount;
      this.store.bankRemitItem.partner = item.partner;
      this.store.bankRemitItem.partnerName = item.partnerName;
      this.store.bankRemitItem.invCurrency = item.invCurrency;
      this.store.bankRemitItem.currAmount = item.amount;
      this.store.bankRemitItem.invNo = item.invoiceName;
      //this.store.bankRemitItem.exchangeRate = ;
      this.store.bankRemitItem.isTransfered = false;
      this.store.bankRemitItem.pterm = item.pdate;
      this.store.bankRemitItem.itemId = 1;

      const id = Number(await this.store.saveItem());
      if (id > 1) {
        this.store.bankRemitItem.itemId = id;
        this.store.bankRemit.items.unshift(this.store.bankRemitItem);
      }
      console.log(item);
    },

    async search(e: Event) {
      e.preventDefault();
      BankRemitApi.getBankOverOutViews(
        this.bankAcc,
        this.partner,
        this.currency,
        this.accDateMin ?? "2000. 01. 01.",
        this.accDateMax ?? "2999. 12. 31.",
        this.pDateMin ?? "2000. 01. 01.",
        this.pDateMax ?? "2999. 12. 31."
      ).then((invoices) => (this.invoices = invoices));

      this.$nextTick(() =>
        this.invoices.forEach((element: BankOverOutView) => {
          element.selected = false;
        })
      );
    },

    clear() {
      this.invoices = [];
      this.bankAcc = "";
      this.partner;
    },

    pagerChanged(p: Pager) {
      this.pager = p;
    },

    filterChange(e: { filter: CompositeFilterDescriptor }) {
      if (this.customFilter) {
        this.$emit("filterChange", e.filter);
      } else {
        this.filter = e.filter;
      }
    },

    sortChange(e: { sort: SortDescriptor[] }) {
      if (this.customSort) {
        this.$emit("sortChange", e.sort);
      } else {
        this.sort = e.sort;
      }
    },
  },

  computed: {
    activeFilter() {
      return this.customFilter ? this.customFilter : this.filter;
    },

    activeSort() {
      return this.customSort ? this.customSort : this.sort;
    },

    activeItems() {
      let items: object[] = this.invoices;
      items = filterBy(items, this.activeFilter);
      items = orderBy(items, this.activeSort);
      return items;
    },

    columns: () => [
      { cell: "detailsButtonTemplate", width: 50, filterable: false },
      // { field: "accDate", title: "Könyvelés dátuma", type: "date", format: "{0: yyyy. MM. dd.}", width: 140 },
      {
        field: "code",
        title: "Prefix",
        width: 100,
      },
      // {
      //   field: "invoiceName",
      //   title: "Bizonylat szám",
      // },
      {
        field: "partnerName",
        title: "Partner",
      },
      {
        field: "pdate",
        title: "Fizetési tétel dátuma",
        cell: "pdateTemplate",
        // type: "date",
        // format: "{0: yyyy. MM. dd.}",
        width: 150,
      },
      {
        field: "amount",
        title: "Összeg",
        cell: "amountTemplate",
        headerClassName: "right_text",
        className: "right_text",
        width: 200,
      },
      {
        field: "invoiceName",
        title: "Bizonylat szám",
      },
      // {
      //   field: "remark",
      //   title: "Megjegyzés",
      // },
      { cell: "commandTemplate", width: "60px" },
      { width: 0, filterable: false },
    ],
  },
});
